import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const FetchCourseApi = createApi({
  reducerPath: "fetchCourseApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getCourseDetails: builder.query({
      query: (courseId: string) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchCourseById(
              id: "${courseId}"
              preview: true
            ) {
              data {
                id
                title
                artifacturl
                duration
                language
                difficultyLevel
                cataloged
                type
                sourceName
                sourceType
                launchDate
                updatedat
                expiryDate
                shortDescription
                longDescription
                demonstrableOutcome
                learningObjective
                learningassistant
                prerequisite
                socialInteractions {
                        contentId
                        contentType
                        interactionCriteria
                    }
                learningassistant
                createdby
                skills
                searchTags {
                  defaultTag
                  contentCategory
                  contentSubCategory
                  contentUsage
                  contentRegion
                  contentDomain
                }
                branding {
                  promo
                  thumbnail
                  banner
                }
                brandingurls {
                  promo
                  thumbnail
                  banner
                }
                stakeholder{
                  owner
                }
                moduleList {
                  id
                  title
                  shortDescription
                  courseId
                  lockedModuleId
                  lockedContentId
                  chapterList {
                    id
          contentId
          isacknowledged
          title
          branding{promo, thumbnail, banner}
          language
          stakeholder{owner, observer, nominationApprover}
          expectedoutcome
          shortdescription
          longdescription
          prerequisite
          sourcename
          sourcetype
          artifacttype
          skills{type, skillid, parentskill}
          duration
          difficultylevel
          launchdate
          expirydate
          artifactid
          brandingurls{promo, thumbnail, banner}
          questioncount
          artifacturl
          moduleid
          contentType
          weblink
          launchtype
          artifacttext
          videosettings {
            pauseOnOutOfFocus
    allowSeek
    allowUnmute
    allowPlaybackSpeedControl
    allowResumePlayback
          }
                  }
                  connectionList {
                    id
                    courseId
                    sourceModuleId
                    nextModuleId
                  }
                }
                contentOccurences
              }
              error
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" }
    }),
    getCourseProgress: builder.query({
      query: (id: any) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchCourseProgress(
              courseId: "${id}"
            ) {
              error
              data {
              progressStatus
                courseId
                progressPercentage
                status
                moduleList {
                  moduleId
                  progressPercentage
                  status
                  lockedModuleId
                  lockedContentId
                  chapterList {
                    contentId
                    contentType
                    progressPercentage
                    moduleId
                    status
                    lockedModuleId
                    lockedContentId
                    securedScore
                  }
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Progress" }
    }),
    getProgressStatus: builder.query({
      query: (id: any) => {
        return {
          url: `/progress/polling/course/${id}`,
          method: "GET"
        };
      },
      extraOptions: { service: "Progress" }
    })
  })
});

export const {
  useGetCourseDetailsQuery,
  useLazyGetCourseDetailsQuery,
  useGetCourseProgressQuery,
  useLazyGetCourseProgressQuery,
  useLazyGetProgressStatusQuery,
  useGetProgressStatusQuery
} = FetchCourseApi;
